export enum ContextHelpId {
  ADD_CONTACT = 'add-contact',
  SEND_GIFT_RECIPIENT = 'send-gift-recipient',
}
